import { LayoutComponent } from '../layout/layout.component';
import { LoginComponent } from './pages/login/login.component';
import { CandidateDetailsComponent } from './master/candidate-details/candidate-details.component';
import { Routes } from '@angular/router';
export const routes :Routes =  [
    {
        path: '',
        redirectTo: 'candidate-details',
        pathMatch: 'full'
    },
 {
        path: '',
        component: LayoutComponent,
        children: [
            { path: '', redirectTo: 'candidate-details', pathMatch: 'full' },
        ]
    },
   { path: 'candidate-details', component: CandidateDetailsComponent },
   { path: '**', redirectTo: 'candidate-details' }];
